module.exports = __webpack_public_path__ + "img/B2.b3427b18.jpg";